import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
type VerticalAlignOption = 'middle' | 'baseline' | 'bottom';

@Component({
  selector: 'app-client-on-stop-warning',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './client-on-stop-warning.component.html',
  styleUrl: './client-on-stop-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientOnStopWarningComponent {
  tooltipText = input<string | null>(null);
  label = input<string>('Special Requirements');
  showLabel = input<boolean>(false);
  verticalAlign = input<VerticalAlignOption>('middle');
}
